import { removeWindowClass } from '@app/utils/helpers';
import { rejects } from 'assert';
import { Gatekeeper } from 'gatekeeper-client-sdk';
import { reloadResources } from 'i18next';
import { resolve } from 'path';
import axios from 'axios';

const url = 'https://api-passport.advanceagro.net';
const url2 = 'https://api-traveling-test.netcomdns.com';
// const url = 'https://api-uat-passport.advanceagro.net';
const url4 = 'https://api-zoom-v2.advanceagro.net';
// const url4 = 'http://localhost:3500';
const url5 = 'https://hr.advanceagro.net/api-center/cdsapi';
// const url5 = 'http://localhost:2500/api-center/cdsapi';

export const loginBy365 = async (serviceid: string) => {
  const params = await Gatekeeper.loginBy365(serviceid);
  console.log(params.token);
  console.log(localStorage.getItem('gatekeeper_token'));
  localStorage.setItem('token', params.token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return params;
};

export const unlink365 = () => {
  Gatekeeper.unlink365();
};

export const manage365 = () => {
  Gatekeeper.manage365();
};

export const loginByAuth = async (
  email: string,
  password: string,
  serviceid: string
) => {
  const data = await Gatekeeper.loginByIdms(email, password, serviceid);
  console.log(data.token);
  console.log(localStorage.getItem('gatekeeper_token'));
  localStorage.setItem('token', data.token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return data;
};

export const downloadOwner = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/driver-owner`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const registerByAuth = async (email: string, password: string) => {
  const token = await Gatekeeper.registerByAuth(email, password);
  localStorage.setItem('token', token);
  removeWindowClass('register-page');
  removeWindowClass('hold-transition');
  return token;
};

export const loginByGoogle = async () => {
  const token = await Gatekeeper.loginByGoogle();
  localStorage.setItem('token', token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return token;
};

export const registerByGoogle = async () => {
  const token = await Gatekeeper.registerByGoogle();
  localStorage.setItem('token', token);
  removeWindowClass('register-page');
  removeWindowClass('hold-transition');
  return token;
};

export const loginByFacebook = async () => {
  const token = await Gatekeeper.loginByFacebook();
  localStorage.setItem('token', token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return token;
};

export const registerByFacebook = async () => {
  const token = await Gatekeeper.registerByFacebook();
  localStorage.setItem('token', token);
  removeWindowClass('register-page');
  removeWindowClass('hold-transition');
  return token;
};

export const downloadReport = async (
  reportid: string,
  date_start: string,
  date_end: string,
  country_code: string
) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url}/qrapi/report?reportid=${reportid}&date_start=${date_start}&date_end=${date_end}&country_code=${country_code}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  const data = res.data;
  return data;
};

export const downloadSmslog = async (redemption_id: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/smslog/${redemption_id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadDashboard = async (
  date_start: string,
  date_end: string,
  country_code: string
) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url}/qrapi/dashboard?date_start=${date_start}&date_end=${date_end}&country_code=${country_code}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  const data = res.data;
  return data;
};

export const downloadDropdown = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/dropdown`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const getQrData = async (qr: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/qr/${qr}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadCampaign = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/campaign`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadAllBatch = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/campaign/all`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadFToken = async (campaign: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/downloadFToken/${campaign}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const sendVoucher = async (input: any) => {
  var urlencoded = new URLSearchParams();
  urlencoded.append('campaign_id', `${input.campaign}`);
  urlencoded.append('customer_id', `${input.redemption_id}`);
  urlencoded.append('customer_name', `${input.name}`);
  urlencoded.append('redemption_id', `${input.redemption_id}`);
  urlencoded.append('country', `${input.token.country}`);
  urlencoded.append('mobile_no', `${input.phone}`);
  urlencoded.append('message', `${input.message}`);

  var myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + input.token.token);
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded
  };
  const response = await fetch(input.token.url, requestOptions);
  const data = response.json();
  console.log(data);
  return data;
};

export const addCampaign = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/qrapi/campaignB64`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const logMe = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/qrapi/logMe`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const addCampaign2 = async (input: any, file: File) => {
  const formData = new FormData();
  for (var key in input) {
    formData.append(key, input[key]);
  }
  formData.append('image', file, file.name);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/qrapi/campaign`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const updateCampaign = async (input: any, file: File) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/qrapi/campaign`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadBlacklist = async (country_code: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/blacklist/${country_code}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const uploadBlacklist = async (country_code: string, input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(
    `${url}/qrapi/blacklist/${country_code}`,
    input,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  const data = res.data;
  return data;
};

export const updateUser = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/qrapi/user`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const deleteCampaign = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.delete(`${url}/qrapi/campaign/${input.CAMPAIGN}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const resendVoucher = async (country_code: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/resend/${country_code}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadPending = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/pending`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadSuperAdmin = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/qrapi/superAdmin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadBatch = async (country_code: string, campaign: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url}/qrapi/batch/${country_code}/${campaign}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  const data = res.data;
  return data;
};

export const uploadSurvey = async (input: any) => {
  // const res = await axios.post(`${url}/qrapi/uploadSurvey`, input, {
  const res = await axios.post(`${url}/qrapi/uploadSurvey`, input, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

//CDS API
export const verifyPinWs = async (pin: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/pin/${pin}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const uploadNgvWs = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/ngv`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const uploadPinWs = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/pins`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadCrWs = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/cr`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//ดึงข้อมูลรายการรออนุมัติรถส่วนตัวของพนักงาน
export const approveCar = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url5}/approve_car_employee`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//อนุมัติรถส่วนตัวพนักงงาน
export const updateVehicleStatus = async (vehicleId: number, status: 'A' | 'F', remark?: string) => {
  const token = localStorage.getItem('gatekeeper_token');

  const res = await axios.post(`${url5}/update_vehicle_status`,
    { vehicleId, status, remark }, // 💡 ส่ง remark แนบไปด้วย
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const uploadPicWs = async (input: any, file: any) => {
  const formData = new FormData();
  for (var key in input) {
    if (key !== 'b64') formData.append(key, input[key]);
  }
  file.forEach((_file: any) => {
    if (_file.file !== null)
      formData.append(`image`, _file.file, _file.file.name);
  });
  const token = localStorage.getItem('gatekeeper_token');
  // http://localhost:3001/cdsapi
  const res = await axios.post(`${url}/cdsapi/pic`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const uploadPicWs2 = async (input: any, file: any) => {
  const formData = new FormData();
  for (var key in input) {
    if (key !== 'b64') formData.append(key, input[key]);
  }
  if (file.file !== null) formData.append(`image`, file.file, file.file.name);

  console.log(formData);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/pic_gps`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const resetDriverWs = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/resetpassword`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadPinlistWs = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/pins`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadDropdownCar = async (staffid: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url5}/dropdown/${staffid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  // const res = await axios.get(`${url}/cdsapi/dropdown/${staffid}`, {
  //   headers: {Authorization: `Bearer ${token}`}
  // });
  // console.log("API Response Status:", res.status);
  // console.log("API Response Data:", res.data);
  const data = res.data;
  return data;
};

export const downloadDropdownCarOnlyMe = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/dropdownme`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadApvCostcenter = async (
  costid: string,
  companyid: string,
  year: string
) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url}/cdsapi/apv/${costid}?company_id=${companyid}&year=${year}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  const data = res.data;
  return data;
};

export const insertApvCostcenter = async (costid: string, input: any) => {
  console.log(costid);
  console.log(input);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/apv/${costid}`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadCars = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/rentalcars`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadCarsAvailable = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  // const res = await axios.post(`http://localhost:3001/cdsapi/rentalcars`, input, {
  const res = await axios.post(`${url}/cdsapi/rentalcars`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadCostCenter = async (
  key: string,
  companyid: string,
  costid: string,
  year: string
) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url2}/api/read?companyid=${companyid}&costid=${costid}&${key}=${year}`,
    {
      headers: {
        'x-auth-token':
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Im5hbWUiOiJjYXJzZXJ2aWNlIn0sImlhdCI6MTY4OTczMTkyMX0.OOen1aihyAZ4xMPfN3ICS8Rv6lr3YCwQgMQ0w5lhPq0'
      }
    }
  );
  console.log(res);
  const data = res.data;
  return data;
};

export const downloadConsent = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/consent`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//export const insertConsent = async () => {
//  const token = localStorage.getItem('gatekeeper_token');
//  const res = await axios.post(
//    `${url}/cdsapi/consent`,
//    {},
//    {
//      headers: {
//        Authorization: `Bearer ${token}`,
//        'Content-Type': 'application/json'
//      }
//    }
//  );
//  const data = res.data;
//  return data;
//};

export const insertConsent = async (id: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(
    `${url}/cdsapi/consent`,
    { id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  const data = res.data;
  return data;
};

export const downloadPlace = async (planid: any, type: string) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/places/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const updatePlanApprove = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/plan/approve`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const updatePlan = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/plan`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const updateExpend = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/expend`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadChat = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/chat/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const recal = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/calMe/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const uploadChat = async (planid: any, message: any) => {
  const input = { message: message };
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/chat/${planid}`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadPhoto = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  // http://localhost:3001/cdsapi/photos/202309020331PMA
  const res = await axios.get(`${url}/cdsapi/photos/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadPath = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  // const res = await axios.get(`${url}/cdsapi/progress/${planid}`, {
  const res = await axios.get(`${url}/cdsapi/progress/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadPathRecost = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/progress_recost/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const insertReCostcenter = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/recostcenter`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const getMyMenu = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/mymenu`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadExpendCar = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/expend/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadBudget = async (value: any, date: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/budget/${value}/${date}`, {
    // const res = await axios.get(`http://localhost:3001/cdsapi/budget/${value}/${date}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadIbc = async (value: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/ibc/${value}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadIbcApv = async (value: any, date: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/ibcApv/${value}/${date}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const addPlan = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/plan`, input, {
    // const res = await axios.post(`http://localhost:3001/cdsapi/plan`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadWaitMe = async (type: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/plans/${type}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//ข้อมูลรถพนักงงาน
export const downloadCarMe = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  // const res = await axios.get(`${url}/cdsapi/cars`, {
  //   headers: {Authorization: `Bearer ${token}`}
  // });
  console.log("tokenที่ได้: ", token);
  const res = await axios.get(`${url5}/cars`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//อัพเดต
export const updateCarMe = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  // const res = await axios.patch(`${url}/cdsapi/car`, input, {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //     'Content-Type': 'application/json'
  //   }
  // });
  const res = await axios.patch(`${url5}/car`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const insertCarWs = async (input: any, file: any) => {
  const formData = new FormData();

  // 1. วนลูปยัดข้อมูลตัวหนังสือลง FormData (ยกเว้น b64)
  for (var key in input) {
    if (key !== 'b64') formData.append(key, input[key]);
  }
  // 2. วนลูปเช็กไฟล์ภาพอย่างปลอดภัยก่อนยัดลง FormData
  if (file && Array.isArray(file)) {
    file.forEach((_file: any) => {
      if (_file) {
        // เคสที่ 1: มาจากโครงสร้างเดิมในสเตต [{id: 1, file: Object}] (สำหรับโหมดเพิ่มรถใหม่ปกติ)
        if (_file.file && _file.file instanceof File) {
          formData.append(`image`, _file.file, _file.file.name);
        }
        // เคสที่ 2: ส่งมาเฉพาะตัวไฟล์ดิบ ๆ เลย (File หรือ Blob)
        else if (_file instanceof File) {
          formData.append(`image`, _file, _file.name);
        }
        // เคสที่ 3: ถ้าเป็น null หรือไม่มีการเปลี่ยนรูปใหม่ในโหมดแก้ไข ก็จะปล่อยข้ามไปอย่างปลอดภัยครับ
      }
    });
  }
  const token = localStorage.getItem('gatekeeper_token');

  const res = await axios.post(`${url5}/car`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });

  const data = res.data;
  return data;
};

//แก้ไขรถส่วนตัวพนักงงาน
export const editCarMe = async (input, files) => {
  const token = localStorage.getItem('gatekeeper_token'); // หรือ Token ที่พี่ใช้งานอยู่
  const formData = new FormData();

  // 1. นำข้อมูลตัวหนังสือ (Brand, Model, VehicleId ฯลฯ) ยัดใส่ FormData
  Object.keys(input).forEach((key) => {
    formData.append(key, input[key]);
  });

  // 2. นำไฟล์รูปภาพยัดใส่ FormData ตามลำดับ (ถ้าพนักงานเลือกรูปใหม่เข้ามา)
  // ดักเช็ก: ถ้าช่องไหนเป็น null (ผู้ใช้ใช้รูปเก่า) จะข้ามไป ไม่ส่งไฟล์เปล่าไปรบกวนหลังบ้าน
  if (files && files.length > 0) {
    files.forEach((item, index) => {
      if (item) {
        // 💡 เปลี่ยนจาก "image" เป็น "image_0" หรือ "image_1" ตามตำแหน่งจริงในฟอร์ม
        formData.append(`image_${index}`, item);
      }
    });
  }

  // 3. ยิง POST ไปที่หลังบ้าน
  const res = await axios.post(`${url5}/edit_car`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`
    }
  });
  return res.data;
};

export const insertDriverWs = async (input: any, file: any) => {
  const formData = new FormData();
  for (var key in input) {
    if (key !== 'b64') formData.append(key, input[key]);
  }
  file.forEach((_file: any) => {
    formData.append(`image`, _file.file, _file.file.name);
  });
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/driver`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const updateDriverWs = async (input: any, file: any) => {
  // console.log(file);
  const formData = new FormData();
  for (var key in input) {
    if (key !== 'b64') formData.append(key, input[key]);
  }
  file.forEach((_file: any) => {
    if (_file.file !== null)
      formData.append(`image`, _file.file, _file.file.name);
  });
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/driver`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const deleteDriverWs = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.delete(`${url}/cdsapi/driver/${input.CAR_ID}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  const data = res.data;
  return data;
};

export const downloadDropdownCar2 = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/cardropdown`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadGroup = async (q: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/groups?q=${q}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadRole = async (q: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/roles?q=${q}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//employee/chatree
export const downloadEmployees = async (q: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/employee/${q}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadMember = async (group_id: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/group/${group_id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadMemberRole = async (role_id: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/role/${role_id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const updateGroup = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/group`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const updateRole = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/role`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadDriver = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  // const res = await axios.get(`http://localhost:3001/cdsapi/driver`, {
  const res = await axios.get(`${url}/cdsapi/driver`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const getDriver = async (planid: any) => {
  console.log(`${url}/cdsapi/driver/${planid}`);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/driver/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//DO
export const downloadDeliveryAdmin = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/doapi/superAdmin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const uploadExcel = async (input: any, date: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(
    `${url}/doapi/delivery`,
    { data: input, date: date },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  const data = res.data;
  return data;
};

export const updatePoItems = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(
    `${url}/doapi/deliveries`,
    { data: input },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  const data = res.data;
  return data;
};

export const updatePoItem = async (input: any, file: any) => {
  console.log(input);
  const formData = new FormData();
  for (var key in input) {
    formData.append(key, input[key]);
  }
  if (file !== null) {
    formData.append(`image`, file, file.name);
  }
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/doapi/delivery`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const downloadDoData = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  console.log(`${url}/doapi/delivery?q=${input.date}`);
  const res = await axios.get(`${url}/doapi/delivery?q=${input.date}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

//HRD
export const downloadDropdownHrd = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url4}/signapi/hrd/dropdown`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const getEmployees = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url4}/signapi/hrd/employees`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const addTraining = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url4}/signapi/hrd/training/add`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadReportCourse = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url4}/signapi/hrd/report`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const onHrdEmail = async (input: any) => {
  // console.log(input);
  // console.log(`${url}/oauth/training-hrd-mail/${input.TRAINING_ID}/${input.TRAINEE.EMPID}`);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url}/oauth/training-hrd-mail/${input.TRAINING_ID}/${input.TRAINEE[0].EMPID}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  const data = res.data;
  return data;
};

export const downloadHrdAdminWs = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/hrd_admin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadHrdWs = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/hrd`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const updateHrdCourse = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url4}/signapi/hrd/training/edit`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const updateHrdSign = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url4}/signapi/hrd/sign/edit`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadHrdTraineeAndExpense = async (training_id: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url4}/signapi/hrd/trainee_expense/${training_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  const data = res.data;
  return data;
};

export const uploadChatHrd = async (trainingid: any, message: any) => {
  const input = { message: message };
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/fpapi/chatHrd/${trainingid}`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadChatHrd = async (trainingid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/fpapi/chatHrd/${trainingid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const uploadPicHrdWs = async (input: any, file: any) => {
  const formData = new FormData();
  for (var key in input) {
    if (key !== 'b64') formData.append(key, input[key]);
  }
  file.forEach((_file: any) => {
    if (_file.file !== null)
      formData.append(`image`, _file.file, _file.file.name);
  });
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/fpapi/pic`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  });
  const data = res.data;
  return data;
};

export const downloadPhotoHrd = async (trainingid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/fpapi/photos/${trainingid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadLastRelated = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url4}/signapi/hrd/last_related`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadPhotoNa = async (planid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/photos_na/${planid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const importPhotoNa = async (planid: any, photo: any) => {
  console.log('MOMO');
  console.log(planid);
  console.log(photo);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/photos_na/${planid}`, photo, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadCarslistWs = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/rental_car`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const addRentalCar = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/cdsapi/rental_car`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const updateRentalCar = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/cdsapi/rental_car`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const downloadcompany = async (input: any) => {
  // {lat: lat, lng: lng}
  console.log(`${url}/cdsapi/company?lat=${input.lat}&lng=${input.lng}`);
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(
    `${url}/cdsapi/company?lat=${input.lat}&lng=${input.lng}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  const data = res.data;
  return data;
};

export const getVdoWs = async (url: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const getUrlFromSf = async (sf_id: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/cdsapi/zoomurl?sf_id=${sf_id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadMenus = async (token: any, location: any) => {
  const res = await axios.get(`${url}/cdsapi/appmenu`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadDrivingLicense = async (empid: any) => {
  const res = await axios.get(`${url4}/signapi/driving/license/${empid}`);

  return res.data;
};

//ประวัติการรับงานของรถบริการ
export const fetchDriverStatusByDate = async (dateStr: string, token?: any) => {
  const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  const res = await axios.get(`${url5}/driver/status-by-date?date=${dateStr}`, config);

  return res.data;
};
